export const GET_SCHEDULES = 'GET_SCHEDULES';
export const SCHEDULE_REQUEST = 'SCHEDULE_REQUEST';
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const SCHEDULE_REQUEST_FAILURE = 'SCHEDULE_REQUEST_FAILURE';